@for (label of env?.labels; track label) {
  <span class="badge badge-secondary" [attr.title]="label.description">{{label.labelName}}</span>&nbsp;
}